import { db } from '../db/schema';

export interface AusstellerSettings {
  titelVor:  string;
  name:      string;
  titelNach: string;
  strasse:   string;
  plz:       string;
  ort:       string;
  land:      string;
  telefon:   string;
  email:     string;
  uid:       string;
  iban:      string;
  bic:       string;
  faArztNr:  string;
}

export const AUSSTELLER_DEFAULT: AusstellerSettings = {
  titelVor:  'Dr. med.',
  name:      'Klaus Karrer, MSc.',
  titelNach: '',
  strasse:   'Bahnhofstraße 12',
  plz:       '8990',
  ort:       'Bad Aussee',
  land:      'AT',
  telefon:   '+43 3622 12345',
  email:     'mail@dr-karrer.com',
  uid:       'ATU99999999',
  iban:      'AT12 3456 7890 1234 5678',
  bic:       'RLNWATWWXXX',
  faArztNr:  '123456',
};

export async function loadAussteller(): Promise<AusstellerSettings> {
  try {
    const row = await db.einstellungen.get('aussteller');
    if (row === undefined) return { ...AUSSTELLER_DEFAULT };
    return JSON.parse(row.value) as AusstellerSettings;
  } catch {
    return { ...AUSSTELLER_DEFAULT };
  }
}

export async function saveAussteller(data: AusstellerSettings): Promise<void> {
  await db.einstellungen.put({ key: 'aussteller', value: JSON.stringify(data) });
}

export async function loadSetting<T>(key: string, fallback: T): Promise<T> {
  try {
    const row = await db.einstellungen.get(key);
    if (row === undefined) return fallback;
    return JSON.parse(row.value) as T;
  } catch {
    return fallback;
  }
}

export async function saveSetting<T>(key: string, value: T): Promise<void> {
  await db.einstellungen.put({ key, value: JSON.stringify(value) });
}
